export default {
      id: "oc-res-idp-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-idp",
      toString: function () {
        return this.url;
      }
    }